import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: в таймлайне истории ПИК выбран другой год.
 */
export function trackPikHistoryYearSelect(year: string): void {
  ca('eventSite', {
    action: 'click_pik_history_year',
    category: 'Promo',
    label: 'pik_history_tab',
    name: 'oldevent',
    page: {
      extra: {
        tab_name: year,
      },
    },
    products: [createDeveloperProduct()],
  });
}
